import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../useMutationState";
export const useSubmitServiceDescriptionFeedback = () => {
  const {
    api
  } = useStoreActions();
  const {
    mutateAsync,
    isPending
  } = useMutationState({
    mutationFn: async _ref => {
      let {
        conversationId,
        data
      } = _ref;
      return api.service.submitServiceDescriptionFeedback(conversationId, data);
    },
    withPageLoader: false
  });
  return {
    submitFeedback: mutateAsync,
    isLoading: isPending
  };
};